<template>
	<div class="jury-control">
		<div v-for="(group, index) in value" :key="index" :class="[`jury-day-${index + 1}`]">
			<div class="form-group row">
				<div class="col-md-12">
					<h3 class="jury-title">ADD/EDIT JURY MEMBER</h3>
				</div>
			</div>
			<div class="form-group row">
				<label class="form-label col-md-2" :for="`Title-${index + 1}`">Name</label>
				<div class="col-md-10">
					<input type="text" class="form-control" v-model="group.name" />
				</div>
			</div>
			<div class="form-group row">
				<label class="form-label col-md-2" :for="`Sponsor-${index + 1}`">Title</label>
				<div class="col-md-10">
					<input type="text" class="form-control" v-model="group.sponsor" />
				</div>
			</div>
			<div class="form-group row">
				<label class="form-label col-md-2" :for="`Description-${index + 1}`">Email</label>
				<div class="col-md-10">
					<textarea type="text" class="form-control" rows="4" v-model="group.description" />
				</div>
			</div>
			<div class="form-group row">
				<div class="col-md-12 text-right">
					<a href="#" class="text-secondary">DELETE JURY MEMBER</a>
				</div>
			</div>
            <div class="form-group row">
				<div class="col-md-12">
					<div class="row">
                        <div class="col-md-6">
                            <button type="button" class="btn btn-block btn-prize">SAVE</button>
                        </div>
                        <div class="col-md-6">
                            <button type="button" class="btn btn-block btn-cancel" @click="cancel(index)">CANCEL</button>
                        </div>
                    </div>
				</div>
			</div>
		</div>
		<AddContentButton color="#C32AA3" @click="onClickAddJury">Add Jury Member</AddContentButton>
	</div>
</template>

<script>
import AddContentButton from '@/components/AddContentButton';
import ImageUploadButton from '@/components/ImageUploadButton';
export default {
	components: {
		AddContentButton,
		ImageUploadButton,
	},
	props: {
		value: {
			type: Array,
			default() {
				return [];
			},
		},
	},
	methods: {
		onClickAddJury() {
			this.value.push({
				name: '',
				sponsor: '',
				description: '',
				value: '',
				images: [],
			});
		},
		cancel(index) {
			this.value.splice(index, 1);
		}
	},
};
</script>

<style lang="scss">
.jury-control {
	.jury-title {
		color: #c32aa3;
		font-size: 1.125rem;
		font-weight: bold;
	}

	.form-control {
		border-radius: 0;
	}

	.delete-instance {
		font-size: 1.125rem;
		cursor: pointer;
	}
	.btn-prize {
		background-color: #c32aa3;
		border: #c32aa3;
		border-radius: 4px;
	}

    .btn-cancel {
		background-color:#58595B;
		border: #58595B;
		border-radius: 4px;
	}
}
</style>
